export default "__VITE_ASSET__gsDSjk8x__"